export const STATUS = Object.freeze({
  Draft: 'Draft',
  Staked: 'Staked',
  Reissued: 'Reissued',
  Live: 'Live',
  Declined: 'Declined',
  Claimed: 'Claimed',
  RequestCancel: 'Request',
  Nullified: 'Nullified',
  Settled: 'Settled'
});

export const getStatusTitle = (stake, status, user) => {
  switch (status) {
    case STATUS.Staked:
      return stake.isMyStake ? status : 'Stake';
    case STATUS.Settled:
      return stake.winner === user.sub ? 'You Won' : 'You Lost';
    case STATUS.RequestCancel:
      return 'Request';
    default:
      return status;
  }
};

//${opponent[0].toUpperCase()}${opponent.slice(1)
export const getStatusText = (stake, opponent, user) => {
  opponent = '@' + opponent;
  switch (stake.status) {
    case STATUS.Staked:
      return stake.isMyStake ? `Waiting for ${opponent} to accept` : `${opponent} has offered you a Stake`;
    case STATUS.Reissued:
      return stake.isMyStake ? `Waiting for a response from ${opponent}` : `${opponent} has edited and offered you a Stake`;
    case STATUS.Declined:
      return stake.playerDeclined === user.sub ? `You declined this stake` : `${opponent} has declined your offer`;
    case STATUS.Live:
      return 'Stake is active and awaiting outcome';
    case STATUS.RequestCancel:
      return stake.playerRequesting === user.sub
        ? 'You have requested cancellation'
        : `${opponent} has requested cancellation`;
    case STATUS.Claimed:
      return stake.playerClaiming === user.sub
        ? `Waiting for a response from ${opponent}`
        : `${opponent} has claimed the win`;
    case STATUS.Settled:
      return stake.winner === user.sub ? 'Congratulations!' : 'Better luck next time :(';
    case STATUS.Nullified:
      return `You and ${opponent} agreed to cancel this stake`;
    default:
      return '';
  }
};

export default STATUS;



// WEBPACK FOOTER //
// ./src/utils/status.js